import styled from 'styled-components';

export const ArtboardContainer = styled.div`
  width: calc(100% - 475px);
  background-color: ${props => props.blur || 'transparent'};
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: row-reverse;
  .moveable-line {
    will-change: transform;
  }
`;

export const DocumentContainer = styled.div`
  position: relative;
  width: calc(100% - 475px);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .moveable-line {
    will-change: transform;
  }
`;

export const FullPageLoaderContainer = styled.div`
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  background-color: rgb(41 48 57 / 0.5);
`;
